import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[libDetailPanel]'
})
export class DetailPanelDirective {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(public templateRef: TemplateRef<any>) {}
}
